export const confirmDelete = (onConfirm: () => void, objectTodelete: string) => () => {
  const message = `Är du säker på att du vill ta bort denna ${objectTodelete}?`;

  if (window.confirm(message)) {
    onConfirm();
  }
};
